export const R40100 = 40100;
export const R40200 = 40200;
export const R40400 = 40400;
// Semantic version for responses tab minimum requirement
export const MIN_AXON_VERSION_FOR_RESPONSES = '4.31.0';
